module.exports = __webpack_public_path__ + "img/Cuisine.51b3741a.jpg";